import React, { useState, useEffect, useCallback } from "react";
import { Input, RadioButton, Select, FileUpload, DatePicker, BasicIconButton } from "components";
import { DNDFormStyle } from "./CreateForm.style";
import { ReactSortable } from "react-sortablejs";

import { ReactComponent as Edit } from "assert/images/Jobs/edit.svg";
import { ReactComponent as Drag } from "assert/images/Jobs/drag.svg";
import { ReactComponent as Delete } from "assert/images/More/delete.svg";
import clsx from "clsx";
import useWindowDimensions from "components/Dimention";
import { swipeModalWidth } from "utils/helper";

export default function DND({ questions = [], handleEdit, handleDelete, initialState, handleDnd, disableAction }) {
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [editIndex, setEditIndex] = useState(null);
  const [disableIcon, setDisableIcon] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (initialState) {
      setEditIndex(null);
      setDisableIcon(false);
    }
  }, [initialState]);

  const handleQuestion = (data) => {
    switch (data?.field) {
      case "Free Text":
        return <Input label={data.question} disabled required={data.required} multiline />;
      case "Dropdown":
        return <Select label={data.question} Options={data.options} required={data.required} value={""} />;
      case "Radio Button":
        return <RadioButton disabled required={data.required} options={data.options} label={data.question} />;
      case "Date Picker":
        return <DatePicker disabled label={data.question} required={data.required} />;
      case "File Upload":
        return <FileUpload disabled label={data.question} required={data.required} />;
      default:
        break;
    }
  };

  const handleEditFunc = useCallback(
    (index) => {
      handleEdit(index);
      setEditIndex(index);
      setDisableIcon(true);
    },
    [handleEdit]
  );

  return (
    <DNDFormStyle isdragging={isDragging}>
      <ReactSortable
        dragClass="sortableDrag"
        animation="200"
        easing="ease-out"
        handle=".handle"
        list={questions}
        setList={handleDnd}
        onStart={() => setIsDragging(true)}
        onEnd={() => setIsDragging(false)}
      >
        {questions.map((item) => (
          <div key={item.id} className={clsx("drag-field-item", editIndex === item.id && "drag-field-bg")}>
            {handleQuestion(item)}
            {!disableAction && (
              <>
                {!item?.disableActionForEmail && <BasicIconButton className='dnd-edit-field' size="small" icon={<Edit />} disabled={disableIcon} onClick={() => handleEditFunc(item.id)} />}
                {!item?.disableActionForEmail && <BasicIconButton
                  size="small"
                  color="error"
                  icon={<Delete />}
                  disabled={disableIcon}
                  onClick={() => handleDelete(item.id)}
                />}
                {isSmallScreen ? <></> : <BasicIconButton size="small" className={"handle form-drag-icon"} icon={<Drag />} disabled={disableIcon} />}
              </>
            )}
          </div>
        ))}
      </ReactSortable>
    </DNDFormStyle>
  );
}
